import { Loader } from "@googlemaps/js-api-loader";

import { ref } from "vue";
import { useOrgSettings } from "@/services";
const googleLoader = ref<Loader | null>(null);

export const useGoogleLoader = (apiKey = "") => {
  if (!googleLoader.value) {
    if (!apiKey) {
      apiKey = useOrgSettings().googleMapsKey;
    }
    googleLoader.value = new Loader({ apiKey });
  }
  return googleLoader;
};
